mutation SetTorahColumnTrim($id: ID!, $skipPrefixWords: Int!, $cutTrailingWords: Int!) {
  setTorahColumnTrim(id: $id, skipPrefixWords: $skipPrefixWords, cutTrailingWords: $cutTrailingWords) {
    ok
    errors
    skipPrefixWords
    cutTrailingWords
  }
}
